import React from "react";
import Routes from "./routes";

import GlobalStyled from "./styles/global";

function App() {
  return (
    <>
      <GlobalStyled />
      <Routes />
    </>
  );
}

export default App;
